/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountType {
  ADMIN = "ADMIN",
  ARCHITECT = "ARCHITECT",
  BUILDER = "BUILDER",
  E1 = "E1",
  ENGINEER = "ENGINEER",
  SUBCONTRACTOR = "SUBCONTRACTOR",
  SUPPLIER = "SUPPLIER",
}

export enum ChurnReasonProductTag {
  BUILDER = "BUILDER",
  CONDEETS = "CONDEETS",
  SUBBIE = "SUBBIE",
  SUPPLIER = "SUPPLIER",
}

export enum ConsultantDiscipline {
  ARCHITECT = "ARCHITECT",
  ARCHITECT_INTERIOR = "ARCHITECT_INTERIOR",
  ARCHITECT_LANDSCAPE = "ARCHITECT_LANDSCAPE",
  CONSULTANT_FIRE = "CONSULTANT_FIRE",
  CONSULTANT_LIGHTING = "CONSULTANT_LIGHTING",
  CONSULTANT_SUSTAINABILITY = "CONSULTANT_SUSTAINABILITY",
  CONSULTANT_TECHNOLOGY = "CONSULTANT_TECHNOLOGY",
  ENGINEER_ACOUSTIC = "ENGINEER_ACOUSTIC",
  ENGINEER_CIVIL = "ENGINEER_CIVIL",
  ENGINEER_ELECTRICAL = "ENGINEER_ELECTRICAL",
  ENGINEER_FIRE = "ENGINEER_FIRE",
  ENGINEER_HYDRO = "ENGINEER_HYDRO",
  ENGINEER_MECH = "ENGINEER_MECH",
  ENGINEER_STRUCTURAL = "ENGINEER_STRUCTURAL",
  ENGINEER_THERMAL = "ENGINEER_THERMAL",
}

export enum InvoiceStatus {
  CANCELLED = "CANCELLED",
  OUTSTANDING = "OUTSTANDING",
  PAID = "PAID",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PENDING = "PENDING",
}

export enum ProjectStatus {
  AWARDED = "AWARDED",
  CLOSED = "CLOSED",
  OPEN = "OPEN",
}

export enum QuoteLogType {
  ADDED = "ADDED",
  COMPLETED = "COMPLETED",
  CREATED_FROM_RFQ = "CREATED_FROM_RFQ",
  DELETED = "DELETED",
  DOWNLOADED = "DOWNLOADED",
  DOWNLOADED_ANON = "DOWNLOADED_ANON",
  DOWNLOADED_BULK_PACKAGE = "DOWNLOADED_BULK_PACKAGE",
  DOWNLOADED_BULK_STAGE = "DOWNLOADED_BULK_STAGE",
  DOWNLOADED_BULK_UNCAT = "DOWNLOADED_BULK_UNCAT",
  FILE_DOWNLOADED = "FILE_DOWNLOADED",
  FILE_DOWNLOADED_ANON = "FILE_DOWNLOADED_ANON",
  PACKAGE_ASSIGNED = "PACKAGE_ASSIGNED",
  REVISED = "REVISED",
  SUBMITTED = "SUBMITTED",
  SUBMITTED_UNCAT = "SUBMITTED_UNCAT",
  VIEWED = "VIEWED",
}

export enum SearchPhraseCategory {
  BRAND = "BRAND",
  COMPETITOR = "COMPETITOR",
  OTHER = "OTHER",
  PRODUCTS = "PRODUCTS",
  SERVICE = "SERVICE",
  TRADE = "TRADE",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ActionConsultantImportLogInput {
  id: GraphQLEntityId;
  actioned: boolean;
}

export interface AddChurnReasonInput {
  tag: string;
  isCustomerFacing: boolean;
  adminText?: string | null;
  customerFacingText?: string | null;
  supportsExtraInformation: boolean;
  extraInformationPrompt?: string | null;
  churnReasonGroupId: GraphQLEntityId;
  productTags: ChurnReasonProductTag[];
}

export interface AddDiscountToLicenseInput {
  offerId: GraphQLEntityId;
  licenseId: GraphQLEntityId;
  activatedAt: GraphQLDateTime;
  expiredAt?: GraphQLDateTime | null;
}

export interface AddLicenseSharerInput {
  licenseProviderId: GraphQLEntityId;
  licenseSharerId: GraphQLEntityId;
}

export interface AddressInput {
  address1: string;
  suburb?: string | null;
  postcode?: string | null;
  city?: string | null;
  state?: StateInput | null;
}

export interface AssignConsultantInput {
  projectId: GraphQLEntityId;
  consultantId: GraphQLEntityId;
  type: number;
}

export interface CreateAbsoluteOfferInput {
  description: string;
  absoluteDiscount: number;
  monthDuration?: number | null;
  lapsesInDays?: number | null;
  productIds: GraphQLEntityId[];
}

export interface CreateAccountOffersForAccountsInput {
  offerId: GraphQLEntityId;
  accountIds: GraphQLEntityId[];
}

export interface CreateConsultantInput {
  name: string;
  abn?: string | null;
  acn?: string | null;
  domain?: string | null;
  typeIds: GraphQLEntityId[];
}

export interface CreateConsultantOfficeInput {
  consultantId: GraphQLEntityId;
  data: OfficeInput;
}

export interface CreateInvoiceFromLicensesInput {
  accountId: GraphQLEntityId;
  licenseIds: GraphQLEntityId[];
}

export interface CreateProRataInvoiceFromLicensesInput {
  accountId: GraphQLEntityId;
  licenseIds: GraphQLEntityId[];
  invoiceDueDate: GraphQLDateTime;
}

export interface CreateRelativeOfferInput {
  description: string;
  relativeDiscount: number;
  monthDuration?: number | null;
  lapsesInDays?: number | null;
  productIds: GraphQLEntityId[];
}

export interface DeleteAccountOfferInput {
  id: GraphQLEntityId;
}

export interface DeleteChurnReasonGroupInput {
  id: GraphQLEntityId;
}

export interface DeleteChurnReasonInput {
  id: GraphQLEntityId;
}

export interface DeleteConsultantOfficeInput {
  id: GraphQLEntityId;
}

export interface DeleteOfferInput {
  id: GraphQLEntityId;
}

export interface EditChurnReasonInput {
  id: GraphQLEntityId;
  isCustomerFacing: boolean;
  adminText?: string | null;
  customerFacingText?: string | null;
  supportsExtraInformation: boolean;
  extraInformationPrompt?: string | null;
  churnReasonGroupId: GraphQLEntityId;
  productTags: ChurnReasonProductTag[];
}

export interface EditConsultantInput {
  id: GraphQLEntityId;
  data: CreateConsultantInput;
}

export interface EditConsultantOfficeInput {
  id: GraphQLEntityId;
  data: OfficeInput;
}

export interface LicenseProRataReductionInput {
  accountId: GraphQLEntityId;
  licenseIds: GraphQLEntityId[];
  dueDate: GraphQLDateTime;
}

export interface OfficeInput {
  name: string;
  email?: string | null;
  phone?: string | null;
  timezone?: string | null;
  address: AddressInput;
}

export interface RemoveLicenseProviderInput {
  licenseSharerId: GraphQLEntityId;
}

export interface StateInput {
  id: GraphQLEntityId;
}

export interface UnassignTypeInput {
  projectId: GraphQLEntityId;
  type: number;
}

export interface UpgradeFromStateLicensesToNationalInput {
  accountId: GraphQLEntityId;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
